"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const token_parser_1 = require("../token-parser");
const token_1 = require("../token");
const assign_name_1 = require("../node/expression/assign-name");
const import_1 = require("../node/import");
class TwingTokenParserImport extends token_parser_1.TwingTokenParser {
    parse(token) {
        let macro = this.parser.getExpressionParser().parseExpression();
        this.parser.getStream().expect(token_1.TwingToken.NAME_TYPE, 'as');
        // template alias
        let var_ = new assign_name_1.TwingNodeExpressionAssignName(this.parser.getStream().expect(token_1.TwingToken.NAME_TYPE).getValue(), token.getLine(), token.getColumn());
        this.parser.getStream().expect(token_1.TwingToken.BLOCK_END_TYPE);
        this.parser.addImportedSymbol('template', var_.getAttribute('name'));
        return new import_1.TwingNodeImport(macro, var_, token.getLine(), token.getColumn(), this.getTag());
    }
    getTag() {
        return 'import';
    }
}
exports.TwingTokenParserImport = TwingTokenParserImport;
